import { ValidationResponse } from "~/gql/types";
import { AnyFolder } from "./types";
import { SharedDrive } from "~/gql/types2";

export const getFolderName = (folder: AnyFolder): string => {
  if (
    folder.__typename === "ProjectFolder" ||
    folder.__typename === "GroupedFolder"
  ) {
    return folder.name;
  }

  return folder.path;
};

export const handleResult = (data: ValidationResponse): string | void => {
  if (data?.errors && data.errors.length > 0) {
    const messages: string[] = [];
    data.errors.forEach((error) => {
      messages.push(error?.message !== "" ? error!.message : "Unhandled error");
    });
    return messages.join(" ");
  }
};

export const mapDriveOptions = (
  driveOptions: SharedDrive[],
  folderFullPath: string
): { label: string; value: string }[] => {
  const options = driveOptions
    .map((drive) => ({
      label: `${drive.driveLetter}:\\ (best for access from the ${drive.physicalLocation} location)`,
      value: drive.driveLetter,
    }))
    .filter((x) => x.value != folderFullPath.split(":")[0]);

  return options;
};
